import ServiceBus from "servicestack/service-bus";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import User from "emun.auth/users/user.model";

const stateMap = {
  General: "info-circle",
  Address: "map-marker",
  Connect: "calendar",
  //Images: 'camera'
  Documents: "paperclip",
};

export default class UserEditorController {
  constructor() {
    basicController(this);
    const $ctrl = this;
    $ctrl.bus = new ServiceBus();
    $ctrl.stateMap = stateMap;
    $ctrl.state = Object.keys(stateMap)[0];

    console.debug("UserEditorController", $ctrl);
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.query = $ctrl.manager.query;
    if (parseInt($ctrl.userId) > 0) {
      $ctrl.bus.send("QueryUsers.json?Id=" + $ctrl.userId).then(
        (response) => {
          if (!response.data.results.length)
            return $ctrl.manager.mutliView(`User not found`);
          $ctrl.edit = true;
          $ctrl.title = "Edit User...";
          $ctrl.manager.user = $ctrl.request = new User(
            response.data.results[0]
          );
          if ($ctrl.manager.user.role === "Vendor") {
            $ctrl.manager.user.vendorId = $ctrl.manager.user.retailerId;
          }
        },
        (r) => $ctrl.manager.mutliView(`User lookup error`)
      );
    } else {
      $ctrl.title = "Create User...";
      $ctrl.manager.user = $ctrl.request = new User();
    }
    $ctrl.mediaQuery = new AutoQuery({
      url: "QueryMedia.json?Realm=UserProfile",
      tagCriteria: {
        UserId: $ctrl.userId,
      },
      autoLoad: true,
      onLoaded: function (args) {
        $ctrl.image = {};
        args.results.forEach(function (arg) {
          $ctrl.image = {
            thumbUrl: arg.url,
            url: arg.url,
          };
        });
      },
    });
  }

  upload($files) {
    let $ctrl = this;
    if ($files && $files.length) {
      let req = {
        request: {
          realm: "UserProfile",
          tags: {
            UserId: $ctrl.userId,
          },
        },
        files: $files,
        urls: [],
      };

      $ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
        $ctrl.image = response.data.media[0];
        $ctrl.request.meta["ProfileImage"] = $ctrl.image.url;
      });
    }
  }

  setState(state, index) {
    const $ctrl = this;
    $ctrl.state = state;
  }

  submit() {
    const $ctrl = this;
    //$ctrl.request.displayName = $ctrl.request.fullName;
    if ($ctrl.request.salesRep) {
      $ctrl.request.bio = $ctrl.request.salesRep.bio;
      //$ctrl.request.repActive = $ctrl.request.salesRep.active;
      $ctrl.request.regionId = $ctrl.request.salesRep.regionId;
    }
    if ($ctrl.request.vendorId && $ctrl.request.role === "Vendor") {
      $ctrl.request.retailerId = $ctrl.request.vendorId;
    }
    if ($ctrl.request.repGroupId && $ctrl.request.role === "RepGroup") {
      $ctrl.request.retailerId = $ctrl.request.repGroupId;
    }
    $ctrl.request.mailAddress = $ctrl.request.address;
    let url =
      ($ctrl.request.id
        ? "UpdateUser"
        : "auth/Register/" + $ctrl.request.role) + ".json";
    let req = Object.assign({}, $ctrl.request);
    req.autoLogin = false;
    delete req.roles;
    //for(let k in req.tags)
    //    req.tags[k] = JSON.stringify(req.tags[k]);
    if ($ctrl.request.retailerPricing == "Msrp") {
        $ctrl.request.meta.UseMsrp = "true";
        $ctrl.request.meta.UseMsrpMultiplier = "false";
        $ctrl.request.meta.MsrpMultiplier = "";
        $ctrl.request.meta.DealerPricing = "false";
    } else if ($ctrl.request.retailerPricing == "MsrpMultiplier") {
        $ctrl.request.meta.UseMsrp = "false";
        $ctrl.request.meta.UseMsrpMultiplier = "true";
        $ctrl.request.meta.DealerPricing = "false";
    } else if ($ctrl.request.retailerPricing == "DealerPricing") {
        $ctrl.request.meta.UseMsrp = "false";
        $ctrl.request.meta.UseMsrpMultiplier = "false";
        $ctrl.request.meta.MsrpMultiplier = "";
        $ctrl.request.meta.DealerPricing = "true";
    }
    $ctrl.bus.send(url, req).then((res) => {
      $ctrl.onSaved({ user: res.data });
      $ctrl.manager.query.load(true);
      $ctrl.manager.mutliView(url);
      return $ctrl.$notify.success("Saved successfully!", {
        title: $ctrl.request.displayName,
        ttl: 5000,
      });
    });
  }
}
